function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { AnalysisType, ChartPlotStyle, ChartType, FunnelOrder, FUNNELS_MATH_TYPES, MetricType, ValueRepresentationType } from 'common/types/reports/bookmark';
import { CardSnabbdom } from '../chart-card';
const STEP_SERIES = [{
  count: 44662,
  avg_time: null,
  avg_time_from_start: null,
  overall_conv_ratio: 1,
  step_conv_ratio: 1,
  property_sum: null
}, {
  count: 21219,
  avg_time: 334703,
  avg_time_from_start: 334703,
  overall_conv_ratio: 0.47510187631543593,
  step_conv_ratio: 0.47510187631543593,
  property_sum: null
}, {
  count: 20179,
  avg_time: 66254,
  avg_time_from_start: 396271,
  overall_conv_ratio: 0.45181586135864943,
  step_conv_ratio: 0.9509873226825015,
  property_sum: null
}, {
  count: 0,
  avg_time: null,
  avg_time_from_start: null,
  overall_conv_ratio: 0,
  step_conv_ratio: 0,
  property_sum: null
}];
const chartProps = (events: string[], cardTitle?: string) => ({
  cardTitle,
  chartOptions: {
    type: "funnel-steps"
  },
  projectId: "",
  bookmark: {
    type: "funnels",
    dashboard: {},
    params: {
      displayOptions: {
        chartType: ChartType.FunnelSteps,
        plotStyle: ChartPlotStyle.Standard,
        analysis: AnalysisType.Linear,
        value: ValueRepresentationType.Absolute,
        funnelStepsSelectedTableColumns: null
      },
      sorting: {},
      sections: {
        cohorts: [],
        filter: [],
        formula: [],
        group: [],
        show: [{
          behavior: {
            type: MetricType.Funnel,
            conversionWindowDuration: 30,
            conversionWindowUnit: "day",
            funnelOrder: FunnelOrder.Loose,
            behaviors: events.map(ev => ({
              type: MetricType.Event,
              name: ev,
              funnelOrder: FunnelOrder.Loose,
              filtersDeterminer: "all",
              filters: []
            }))
          },
          isExpanded: true,
          measurement: {
            math: FUNNELS_MATH_TYPES.CONVERSION_RATE_UNIQUE
          }
        }],
        time: [{
          dateRangeType: "in the last",
          window: {
            unit: "day",
            value: 30
          },
          unit: "day"
        }]
      }
    },
    can_view: true
  },
  chartParams: {
    computed_at: "2023-11-19T14:29:22.488119+00:00",
    headers: ["$funnel", "Metric", "Step"],
    series: {
      ["".concat(events[0], " through ").concat(events[events.length - 1])]: _objectSpread({}, Object.fromEntries(["property_sum", "step_conv_ratio", "avg_time_from_start", "count", "overall_conv_ratio", "avg_time"].map(key => [key, Object.fromEntries(events.map((ev, ind) => ["".concat(ind + 1, ". ").concat(ev), {
        all: STEP_SERIES[ind][key]
      }]))])))
    },
    meta: {
      min_sampling_factor: 1,
      time_period_settings: {
        quarter_start_month: 1
      },
      report_sections: {
        group: [],
        show: [{
          metric_key: "".concat(events[0], " through ").concat(events[events.length - 1])
        }]
      }
    }
  },
  dataGroups: null
});
export const FunnelPreview = (_ref: {
  events: string[];
  cardTitle?: string;
}) => {
  let {
    events,
    cardTitle
  }: {
    events: string[];
    cardTitle?: string;
  } = _ref;
  //@ts-ignore
  return <CardSnabbdom params={chartProps(events, cardTitle)} data-sentry-element="CardSnabbdom" data-sentry-component="FunnelPreview" data-sentry-source-file="funnel.tsx" />;
};